import { useParams } from "react-router-dom";

/**
 * Centralized language extraction and normalization from the URL.
 * Returns: { language, languageId }
 */
export function useLanguage() {
    let { language } = useParams();
    let normalized = "de";
    let languageId = 0;
    if (typeof language === "string") {
        switch (language.toLowerCase()) {
            case "de":
                normalized = "de";
                languageId = 1;
                break;
            case "fr":
                normalized = "fr";
                languageId = 2;
                break;
            case "en":
                normalized = "en";
                languageId = 3;
                break;
            case "it":
                normalized = "it";
                languageId = 4;
                break;
            default:
                normalized = "de";
                languageId = 0;
                break;
        }
    }
    return { language: normalized, languageId };
}
